import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZDeviceRegisterDetailsData = z.object({
  readingTime: z.string().nullable(),
  value: z.number().nullable(),
  indexValue: z.number().nullable(),
  registerName: z.string(),
  units: z.string().nullable(),
  formattedValue: z.string().nullable(),
  cimCodeId: z.string(),
  colorValue: z.string()
})

export const ZregisterData = z.object({
  device_id: z.string(),
  device_name: z.string(),
  registerReadings: z.array(ZDeviceRegisterDetailsData)
})

export const ZHeaderData = z.object({
  asset_id: z.string(),
  asset_name: z.string(),
  tenant_id: z.string(),
  devices: z.array(ZregisterData)
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZHeaderData
})

export type headerSummaryAssetRegisterDashboard = z.infer<typeof ZHeaderData>
export type headerDataAssetRegisterDashboard = z.infer<typeof ZApiResponse>

export async function getAssetDashboardHeaderRegisterSummary (
  siteId: string,
  assetId: string,
  graphName: string,
  requestParameter: any,
  isdefault: boolean,
  onSuccess: (HealthScoreAssetDashboard: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/dashboard/assetStatus/summary/${siteId}/${assetId}?graphName=${graphName}&isDefault=${isdefault.toString()}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else if (response.status === 204) {
        onFailure('No Data Found', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
